import * as ActionTypes from '../ActionTypes';

const InitialState = {
    isLoading: false,
    success: false,
    error: false,
    successMessage: "",
    errorMessage: "",
    report_schedule_data: [],
};

const ReportSchedulerReducer = function (state = InitialState, action) {
    switch (action.type) {
        // Get Report Schedule
        case ActionTypes.REPORT_SCHEDULE_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                successMessage: "",
                error: false,
                errorMessage: "",
                report_schedule_data: [],
            };
        case ActionTypes.REPORT_SCHEDULE_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                report_schedule_data: action.payload?.data?.data?.[0]?.fn_get_report_schedule,
            };
        case ActionTypes.REPORT_SCHEDULE_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message,
            };

        // Update Report Schedule
        case ActionTypes.REPORT_SCHEDULE_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.REPORT_SCHEDULE_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                report_schedule_data: action.payload?.data?.data?.[0]?.fn_upsert_report_schedule,
            };
        case ActionTypes.REPORT_SCHEDULE_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message,
            };

        // Delete Report Schedule
        case ActionTypes.REPORT_SCHEDULE_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.REPORT_SCHEDULE_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                report_schedule_data: action.payload?.data?.data?.[0]?.fn_delete_report_schedule,
            };
        case ActionTypes.REPORT_SCHEDULE_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message,
            };

        default:
            return state;
    }
};

export default ReportSchedulerReducer;